module.exports = __webpack_public_path__ + "static/media/pcb4.6538deee.jpg";